<template>
  <section
    class="flex items-center justify-center rounded border border-yellow-500 bg-yellow-20 p-5"
  >
    <div class="flex items-start justify-center gap-2">
      <svg
        class="-mt-2 h-8 w-8"
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
      >
        <path
          d="M5.83203 5.39062C6.63481 7.74145 8.48121 9.58785 10.832 10.3906C8.48121 11.1934 6.63481 13.0398 5.83203 15.3906C5.02926 13.0398 3.18286 11.1934 0.832031 10.3906C3.18285 9.58785 5.02926 7.74145 5.83203 5.39062Z"
          fill="#F8C617"
        />
        <path
          d="M11.832 0.390625C12.3137 1.80112 13.4215 2.90896 14.832 3.39062C13.4215 3.87229 12.3137 4.98013 11.832 6.39062C11.3504 4.98013 10.2425 3.87229 8.83203 3.39062C10.2425 2.90896 11.3504 1.80112 11.832 0.390625Z"
          fill="#F8C617"
        />
      </svg>
      <p class="text-left text-xs text-dark-blue">
        <span class="font-semibold text-yellow-500 underline">
          Request Verification
        </span>
        of this broker to confirm their {{ type }}
      </p>
    </div>
  </section>
</template>

<script setup>
import { defineProps, computed } from 'vue';
const props = defineProps({
  type: {
    type: String,
  },
});

const type = computed(() => {
  switch (props.type) {
    case 'rateConfirmation':
      return 'rate confirmation contacts.';
    case 'billingContacts':
      return 'secure invoicing contacts.';
    case 'digitalActivity':
      return 'digital footprint.';
    default:
      break;
  }
  return props.type || 'broker';
});
</script>
